import React, { Component } from "react";
import { 
  Stepper, 
  Step, 
  StepLabel, 
  Button, 
  CircularProgress, 
  Snackbar, 
  Slide,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Grid,
  Divider
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import Http from "../../../Http";
import { withRouter } from "react-router-dom";
import moment from "moment";
import "./FacturarCreditoV2.css";

import GuiasSelectV2 from "./GuiasSelectV2";
import ConceptosEditV2 from "./ConceptosEditV2";

const steps = ["Configuración", "Selección de Guías", "Revisión de Conceptos", "Previsualización y Timbrado"];

class FacturarCreditoV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      loading: false,
      sbOpen: false,
      sbMsg: "",
      confirmTimbrar: false,
      
      // Factura Data
      id: null,
      id_cliente: null,
      clienteObj: null,
      start_date: moment(new Date(2015, 1, 1)).format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      cliente_cfdi_uso: "",
      cliente_forma_pago: "",
      cliente_metodo_pago: "",
      flete_logistico: false,
      guias: [],
      conceptos: [],
      totales: {},
      timbrado: false,
      FFO: null,
      
      // Catalogos
      clientes: [],
      cfdi_usos: [],
      formas_pago: [],
      metodos_pago: [],
      
      previewUrl: ""
    };
  }

  componentDidMount() {
    this.loadCatalogos();
    if (this.props.match.params.id) {
      this.loadPreds(this.props.match.params.id);
    }
  }

  loadCatalogos = async () => {
    try {
      const Res = await Http.get("facturacion/form?initialdata=true");
      if (!Res.error) {
        this.setState({
          cfdi_usos: Res.data.cfdi_usos || [],
          formas_pago: Res.data.formas_pago || [],
          metodos_pago: Res.data.metodos_pago || []
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  onClientSearch = async (event, value) => {
    if (!value) return;
    try {
      const Res = await Http.get(`facturacion/form?cliente=${value}`);
      if (!Res.error && Res.data.clientes) {
        this.setState({ clientes: Res.data.clientes });
      }
    } catch (e) {
      console.error(e);
    }
  }

  loadPreds = async (id) => {
    this.setState({ loading: true });
    try {
      const Res = await Http.get(`facturacion-v2/factura-info/${id}`);
      if (!Res.error) {
        const { data } = Res;
        const guias = data.guias.map(g => g.guia_id);
        const timbrado = data.timbrado === 1 || data.timbrado === true;
        
        this.setState({
          id: data.id,
          id_cliente: data.id_cliente,
          clienteObj: { id: data.id_cliente, cliente: data.receptor_razon_social },
          cliente_cfdi_uso: data.receptor_id_uso_cfdi || "",
          cliente_forma_pago: data.id_forma_pago || "",
          cliente_metodo_pago: data.id_metodo_pago || "",
          guias,
          conceptos: data.conceptos || [],
          totales: {
            subtotal: data.subtotal,
            iva: data.iva,
            retencion: data.retencion,
            total: data.total
          },
          timbrado,
          FFO: data.FFO,
          activeStep: timbrado ? 3 : 0 // Si está timbrado, vamos al final
        }, () => {
          if (timbrado) {
            this.fetchPreview(data.id);
          }
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  searchCliente = async (clienteId) => {
    if (clienteId) {
      let Resp = await Http.get(`cliente/one/${clienteId}`);
      if (!Resp.error) {
        const { cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago } = Resp.data;
        this.setState({
          cliente_cfdi_uso: cliente_cfdi_uso || "",
          cliente_forma_pago: cliente_forma_pago || "",
          cliente_metodo_pago: cliente_metodo_pago || ""
        });
      }
    }
  };

  handleNext = async () => {
    const { activeStep } = this.state;
    if (activeStep === 0) {
      if (!this.state.id_cliente) {
        return this.setState({ sbOpen: true, sbMsg: "Seleccione un cliente." });
      }
      this.setState({ activeStep: 1 });
    } 
    else if (activeStep === 1) {
      if (this.state.guias.length === 0) {
        return this.setState({ sbOpen: true, sbMsg: "Seleccione al menos una guía." });
      }
      await this.guardarBorrador();
    }
    else if (activeStep === 2) {
      if (!this.state.cliente_cfdi_uso || !this.state.cliente_forma_pago || !this.state.cliente_metodo_pago) {
        return this.setState({ sbOpen: true, sbMsg: "Complete todos los campos obligatorios (Uso CFDI, Forma y Método de pago)." });
      }
      await this.generarPreview();
    }
  };

  handleBack = () => {
    this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }));
  };

  guardarBorrador = async () => {
    this.setState({ loading: true });
    
    const {
      id, id_cliente, guias, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, flete_logistico, conceptos
    } = this.state;

    // Crear mapa de descripciones_custom
    let descripciones_custom = {};
    conceptos.forEach(c => {
      if (c.concepto && c.descripcion) {
        descripciones_custom[c.concepto] = c.descripcion;
      }
    });

    const vals = {
      id,
      cliente: id_cliente,
      guias,
      cliente_cfdi_uso,
      cliente_forma_pago,
      cliente_metodo_pago,
      flete_logistico,
      timbrar: false,
      descripciones_custom: Object.keys(descripciones_custom).length > 0 ? descripciones_custom : null
    };

    try {
      const Resp = await Http.post("facturacion-v2/facturar-credito", vals);
      if (!Resp.error) {
        const previewId = Resp.data.id;
        
        if (!id) {
          this.setState({ id: previewId });
          this.props.history.replace(`/Ventas/FacturarCreditoV2/${previewId}`);
        }
        
        await this.loadConceptos(previewId);
        this.setState({ activeStep: 2 });
      } else {
        this.setState({ sbOpen: true, sbMsg: Resp.errMsg });
      }
    } catch (e) {
      console.error(e);
      this.setState({ sbOpen: true, sbMsg: "Error inesperado" });
    } finally {
      this.setState({ loading: false });
    }
  };

  loadConceptos = async (facturaId) => {
    const Res = await Http.get(`facturacion-v2/factura-info/${facturaId}`);
    if (!Res.error && Res.data) {
      this.setState({
        conceptos: Res.data.conceptos || [],
        totales: {
          subtotal: Res.data.subtotal,
          iva: Res.data.iva,
          retencion: Res.data.retencion,
          total: Res.data.total
        }
      });
    }
  };

  onConceptoDescChange = (index, value) => {
    let newConceptos = [...this.state.conceptos];
    newConceptos[index].descripcion = value;
    this.setState({ conceptos: newConceptos });
  };

  generarPreview = async () => {
    this.setState({ loading: true });
    
    // Primero, volvemos a guardar el borrador para asegurar que las descripciones nuevas se guarden
    const { id, id_cliente, guias, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, flete_logistico, conceptos } = this.state;
    
    let descripciones_custom = {};
    conceptos.forEach(c => {
      if (c.concepto && c.descripcion) {
        descripciones_custom[c.concepto] = c.descripcion;
      }
    });

    const vals = {
      id, cliente: id_cliente, guias, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, flete_logistico, timbrar: false, descripciones_custom
    };

    try {
      const Resp = await Http.post("facturacion-v2/facturar-credito", vals);
      if (!Resp.error) {
        await this.fetchPreview(id);
        this.setState({ activeStep: 3 });
      } else {
        this.setState({ sbOpen: true, sbMsg: Resp.errMsg });
      }
    } catch (e) {
      console.error(e);
      this.setState({ sbOpen: true, sbMsg: "Error inesperado" });
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchPreview = async (facturaId) => {
    try {
      const pdfResp = await Http.post("facturacion/file", { factura_id: facturaId, type: "pdf" }, true, "arraybuffer");
      if (pdfResp && !pdfResp.error) {
        const blob = new Blob([pdfResp], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        this.setState({ previewUrl: url });
      } else {
        this.setState({ sbOpen: true, sbMsg: pdfResp.errMsg || "Error al generar PDF" });
      }
    } catch (e) {
      console.error(e);
    }
  };

  ejecutarTimbrado = async () => {
    this.setState({ loading: true, confirmTimbrar: false });
    
    const { id, id_cliente, guias, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, flete_logistico, conceptos } = this.state;
    
    let descripciones_custom = {};
    conceptos.forEach(c => {
      descripciones_custom[c.concepto] = c.descripcion;
    });

    const vals = {
      id, cliente: id_cliente, guias, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, flete_logistico,
      timbrar: true,
      descripciones_custom
    };

    try {
      const Resp = await Http.post("facturacion-v2/facturar-credito", vals);
      if (!Resp.error) {
        this.setState({ sbOpen: true, sbMsg: "¡Factura timbrada exitosamente!" });
        window.location.reload();
      } else {
        this.setState({ sbOpen: true, sbMsg: Resp.errMsg });
      }
    } catch (e) {
      console.error(e);
      this.setState({ sbOpen: true, sbMsg: "Error al timbrar" });
    } finally {
      this.setState({ loading: false });
    }
  };

  renderStepContent = (step) => {
    const { 
      clientes, cfdi_usos, formas_pago, metodos_pago, 
      clienteObj, start_date, end_date, cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago, flete_logistico,
      id_cliente, guias, id, timbrado, conceptos, totales, previewUrl
    } = this.state;

    switch (step) {
      case 0:
        return (
          <div className="step-card">
            <Typography variant="h6" gutterBottom>Configuración de la Factura</Typography>
            <Grid container spacing={2} style={{ marginBottom: 24, marginTop: 12 }}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={clientes}
                  getOptionLabel={(option) => option.cliente ? option.id + " - " + option.cliente : ""}
                  value={clienteObj}
                  onInputChange={this.onClientSearch}
                  onChange={(e, val) => {
                    this.setState({ clienteObj: val, id_cliente: val ? val.id : null });
                    if(val) this.searchCliente(val.id);
                  }}
                  disabled={timbrado}
                  renderInput={(params) => <TextField {...params} label="Cliente *" variant="outlined" size="small" />}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Fecha Inicial *"
                  type="date"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={start_date}
                  onChange={e => this.setState({ start_date: e.target.value })}
                  disabled={timbrado}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Fecha Final *"
                  type="date"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={end_date}
                  onChange={e => this.setState({ end_date: e.target.value })}
                  disabled={timbrado}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
            {!timbrado && (
              <div className="actions-container">
                <Button variant="contained" color="primary" onClick={this.handleNext} disabled={!id_cliente}>
                  Buscar Guías →
                </Button>
              </div>
            )}
          </div>
        );
      case 1:
        return (
          <div className="step-card">
            <GuiasSelectV2
              id_cliente={id_cliente}
              start_date={start_date}
              end_date={end_date}
              guias={guias}
              id={id}
              timbrado={timbrado}
              onChangeGuias={g => this.setState({ guias: g })}
            />
            {!timbrado && (
              <div className="actions-container">
                <Button variant="outlined" onClick={this.handleBack} disabled={this.state.loading}>
                  ← Anterior
                </Button>
                <Button variant="contained" color="primary" onClick={this.handleNext} disabled={this.state.loading || guias.length === 0}>
                  {this.state.loading ? <CircularProgress size={20} color="inherit" /> : "Generar Conceptos →"}
                </Button>
              </div>
            )}
          </div>
        );
      case 2:
        return (
          <div className="step-card">
            {/* Sección 1: Datos de Facturación */}
            <Box mb={4}>
              <Typography variant="h6" color="primary" gutterBottom style={{ fontWeight: 600 }}>
                1. Datos de Facturación (CFDI y Pago)
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Especifique el método de facturación y las condiciones del CFDI para este cliente.
              </Typography>
              <Divider style={{ margin: "8px 0 20px 0" }} />
              
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    label="Uso CFDI *"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={cliente_cfdi_uso}
                    onChange={e => this.setState({ cliente_cfdi_uso: e.target.value })}
                    disabled={timbrado}
                  >
                    {cfdi_usos.map(u => <MenuItem key={u.id} value={u.id}>{u.cfdi_uso_nombre}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    label="Forma de pago *"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={cliente_forma_pago}
                    onChange={e => this.setState({ cliente_forma_pago: e.target.value })}
                    disabled={timbrado}
                  >
                    {formas_pago.map(f => <MenuItem key={f.id} value={f.id}>{f.forma_nombre}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    select
                    label="Método de pago *"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={cliente_metodo_pago}
                    onChange={e => this.setState({ cliente_metodo_pago: e.target.value })}
                    disabled={timbrado}
                  >
                    {metodos_pago.map(m => <MenuItem key={m.id} value={m.id}>{m.metodo_nombre}</MenuItem>)}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox 
                        checked={flete_logistico} 
                        onChange={e => this.setState({ flete_logistico: e.target.checked }, () => this.guardarBorrador())} 
                        disabled={timbrado || this.state.loading} 
                        color="primary" 
                      />
                    }
                    label="Reemplazar Flete por Servicio Logístico (Quita la retención de IVA e intercambia clave SAT a Logística)"
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Sección 2: Conceptos a Facturar */}
            <Box mb={2}>
              <Typography variant="h6" color="primary" gutterBottom style={{ fontWeight: 600 }}>
                2. Conceptos a Facturar
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Personalice las descripciones de los conceptos si lo requiere. Se muestran con su respectiva clave SAT de producto/servicio.
              </Typography>
              <Divider style={{ margin: "8px 0 20px 0" }} />

              <ConceptosEditV2 
                conceptos={conceptos}
                totales={totales}
                onDescChange={this.onConceptoDescChange}
                disabled={timbrado}
              />
            </Box>
            {!timbrado && (
              <div className="actions-container">
                <Button variant="outlined" onClick={this.handleBack} disabled={this.state.loading}>
                  ← Anterior
                </Button>
                <Button variant="contained" color="primary" onClick={this.handleNext} disabled={this.state.loading}>
                  {this.state.loading ? <CircularProgress size={20} color="inherit" /> : "Previsualizar Factura →"}
                </Button>
              </div>
            )}
          </div>
        );
      case 3:
        return (
          <div className="step-card">
            <Typography variant="h6" gutterBottom>Previsualización</Typography>
            <div className="preview-container">
              {previewUrl ? (
                <iframe src={previewUrl} title="Preview" width="100%" height="100%" style={{ border: "none" }} />
              ) : (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                  <CircularProgress />
                </div>
              )}
            </div>
            {!timbrado && (
              <div className="actions-container">
                <Button variant="outlined" onClick={this.handleBack} disabled={this.state.loading}>
                  ← Regresar a Editar
                </Button>
                <Button variant="contained" color="secondary" onClick={() => this.setState({ confirmTimbrar: true })} disabled={this.state.loading}>
                  Timbrar Factura
                </Button>
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { activeStep, timbrado, FFO, confirmTimbrar, sbOpen, sbMsg } = this.state;

    return (
      <div className="factura-v2-container">
        <div className="factura-v2-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          <div>
            <h1 style={{ margin: 0 }}>Facturación de Crédito V2</h1>
          </div>
          <Button 
            variant="outlined" 
            color="default" 
            size="small"
            onClick={() => {
              const currentId = this.state.id || this.props.match.params.id;
              this.props.history.push(`/Ventas/FacturarCreditoV1${currentId ? `/${currentId}` : ''}`);
            }}
          >
            ↩ Usar Versión Anterior (V1)
          </Button>
        </div>

        {timbrado && (
          <div className="status-banner">
            ✓ Factura Timbrada — Folio Fiscal: {FFO}
          </div>
        )}

        {!timbrado && (
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        )}

        <div className="step-content">
          {this.renderStepContent(activeStep)}
        </div>

        <Dialog open={confirmTimbrar} onClose={() => this.setState({ confirmTimbrar: false })}>
          <DialogTitle>Confirmar Timbrado</DialogTitle>
          <DialogContent>
            <Typography>
              ¿Estás seguro de timbrar esta factura? Esta acción es irreversible y enviará el CFDI al SAT.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ confirmTimbrar: false })} color="default">
              Cancelar
            </Button>
            <Button onClick={this.ejecutarTimbrado} color="secondary" variant="contained">
              Sí, Timbrar
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={sbOpen}
          onClose={() => this.setState({ sbOpen: false })}
          TransitionComponent={Slide}
          message={sbMsg}
          autoHideDuration={4000}
        />
      </div>
    );
  }
}

export default withRouter(FacturarCreditoV2);
